import { render, staticRenderFns } from "./importacoes-ofx.vue?vue&type=template&id=6bb9623d&"
import script from "./importacoes-ofx.vue?vue&type=script&lang=js&"
export * from "./importacoes-ofx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports